/**
 * Application configuration
 * Environment variables and constants
 */

/**
 * Backend API base URL
 * Can be overridden by REACT_APP_API_URL environment variable
 */
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://collab.intellium.com.tr';

/**
 * API endpoints
 */
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: `${API_BASE_URL}/api/auth/login`,
    REGISTER: `${API_BASE_URL}/api/auth/register`,
  },
  COLLAB: {
    HUB: `${API_BASE_URL}/collabHub`,
  },
} as const;

/**
 * Storage keys
 */
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  REFRESH_TOKEN: 'refresh_token',
  AUTH_USER: 'auth_user',
  TOKEN_EXPIRY: 'token_expiry',
} as const;

/**
 * Application constants
 */
export const APP_CONFIG = {
  MAX_RECENT_PROJECTS: 10,
  TOKEN_REFRESH_THRESHOLD: 5 * 60 * 1000, // 5 minutes before expiry
} as const;
